import 'core-js/proposals/reflect-metadata';

import { Serializable, jsonProperty } from 'ts-serializable';

export class CompanyHead extends Serializable{
    
    @jsonProperty(String, null)
    nome: string | null = '';

    @jsonProperty(String, null)
    telefone: string | null = '';

    @jsonProperty(String, null)
    telefone2: string | null = '';

    @jsonProperty(String, null)
    cpf: string | null = '';

    @jsonProperty(String, null)
    email: string | null = '';

}